// Module
var code = `<div class="alertItemSideBar" on-click="onItemClick">
    <div id="symbolLogo" class="alertItemSideBar-symbol-img">
        {{{svgLogo}}}
    </div>

    <div class="alertItemSideBar-body">
        <div class="alertItemSideBar-body-container">
            <div class="alertItemSideBar-body-container-symbol">
                <div id="symbolName" class="alertItemSideBar-body-container-symbol-name">{{.symbolName}}</div>
                <div id="symbolDesc" class="alertItemSideBar-body-container-symbol-desc">{{.symbolDescription}}</div>
            </div>

            <div class="alertItemSideBar-body-container-actions">
                <div class="alertItemSideBar-body-container-actions-text {{#if .activeAlert}}_green{{else}}_red{{/if}}">
                    {{.activeText}}
                </div>

                <div class="alertItemSideBar-body-container-actions-img">
                    <div id="playStop" class="icon" on-click="@this.onActionButtonClick(event,playStopAction)">
                        <svg>
                            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{#if .activeAlert}}stopIcon{{else}}playIcon{{/if}}"></use>
                        </svg>
                    </div>
                    <div id="editPen" class="icon" on-click="@this.onActionButtonClick(event,editAction)">
                        <svg>
                            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#editIcon"></use>
                        </svg>
                    </div>
                    <div id="close" class="icon" on-click="@this.onActionButtonClick(event,closeAction)">
                        <svg>
                            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#closeCrossBtn"></use>
                        </svg>
                    </div>
                </div>
            </div>
        </div>

        <div id="conditionText" class="alertItemSideBar-body-condition">
            {{.conditionText}}
        </div>
    </div>
</div>`;
// Exports
export default code;